import React, { useState, useContext } from "react";
import { Modal, Input, message } from "antd";
import Template from "../assests/Happy Anniversary Instagram Post.png";
import TestImage from "../assests/TestImage.jpg";
import axios from "axios";
import { AuthContext } from "../context/AuthContext"
import UserAvatar from "../assests/user_avatar.png"

const { TextArea } = Input;

export default function WorkCard({ employee }) {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [wishText, setWishText] = useState("");
    const { backUrl, authData } = useContext(AuthContext)

    const employeeName =
        employee?.id !== 34 ? employee?.full_name : employee?.user?.last_name;
    const organizationName = employee?.organisation_name;
    const departmentName = employee?.department_name;
    const designation = employee?.designation_name;
    const years = employee?.years_completed

    const showModal = () => setIsModalVisible(true);
    const handleCancel = () => setIsModalVisible(false);

    console.log("Employee Photo : ", employee)

    const handleSendWish = async () => {
        if (!wishText.trim()) {
            message.warning("Please enter your wish before sending 🎂");
            return;
        }

        try {
            await axios.post(
                `${backUrl}/api/probation/celebrations/send/`,
                {
                    receiver_id: employee?.id,
                    occasion: "WORK_ANNIVERSARY",
                    message: wishText,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authData?.access}`,
                    },
                }
            );


            console.log(`Wish sent to ${employeeName}: ${wishText}`);
            alert("🎉 Your wish has been sent successfully!");
            setWishText("");
            setIsModalVisible(false);
        } catch (error) {
            console.error("Error sending wish:", error);
            message.error("Failed to send your wish. Please try again.");
        }
    };

    return (
        <div
            style={{
                position: "relative",
                width: "430px",
                height: "230px",
                overflow: "hidden",
                margin: "0 auto",
                borderRadius: "12px",
                boxShadow: "0 6px 18px rgba(0,0,0,0.3)",
                fontFamily: "'Dancing Script', cursive",
            }}
        >
            {/* 🎨 Background template */}
            <img
                src={Template}
                alt="Birthday Template"
                style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    opacity: 0.8
                }}
            />

            {/* 🖼️ Employee photo */}
            <img
                src={employee?.photo || UserAvatar}
                alt="Employee"
                style={{
                    position: "absolute",
                    top: "50px",
                    left: "50px",
                    width: "117px",
                    height: "122px",
                    objectFit: "cover",
                    borderRadius: "8px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
                }}
            />

            {/* ✨ Text details */}
            <div
                style={{
                    position: "absolute",
                    top: "70px",
                    left: "220px",
                    color: "#3b2b2b",
                    textAlign: "left",
                    lineHeight: "1.3",
                }}
            >
                <h2
                    style={{
                        margin: "0 0 10px 0",
                        fontSize: "12px",
                        color: "#236920ff",
                        textShadow: "2px 2px 4px rgba(0,0,0,0.2)",
                    }}
                >
                    {employeeName}! 🎉
                </h2>
                <p style={{ margin: "6px 0", fontSize: "10px", color: "#5a3939" }}>
                    {designation}
                </p>
                <p style={{ margin: "6px 0", fontSize: "10px", color: "#5a3939" }}>
                    {departmentName} Department
                </p>
                <p style={{ margin: "6px 0", fontSize: "10px", color: "#5a3939" }}>
                    {organizationName}
                </p>
                <p style={{ margin: "6px 0", fontSize: "10px", color: "#5a3939" }}>
                    Years Completed : {years}
                </p>

                <button
                    onClick={showModal}
                    style={{
                        marginTop: "10px",
                        padding: "8px 20px",
                        backgroundColor: "#ff7f7f",
                        color: "#fff",
                        border: "none",
                        borderRadius: "25px",
                        fontSize: "10px",
                        cursor: "pointer",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                        transition: "all 0.3s ease",
                    }}
                    onMouseOver={(e) =>
                        (e.currentTarget.style.backgroundColor = "#192b0fff")
                    }
                    onMouseOut={(e) =>
                        (e.currentTarget.style.backgroundColor = "#47851dff")
                    }
                >
                    Send Wishes
                </button>
            </div>

            {/* 💬 Modal for Sending Wishes */}
            <Modal
                title={`Send a Wish to ${employeeName} 🎂`}
                open={isModalVisible}
                onCancel={handleCancel}
                onOk={handleSendWish}
                okText="Send"
                color="green"
                cancelText="Cancel"
                centered
                okButtonProps={{
                    style: {
                        backgroundColor: "#47851dff",
                        borderColor: "#192b0fff",
                        color: "#192b0fff",
                        fontWeight: 600,
                        transition: "all 0.3s ease",
                    },
                    onMouseEnter: (e) => (e.currentTarget.style.backgroundColor = "#47851dff"),
                    onMouseLeave: (e) => (e.currentTarget.style.backgroundColor = "#47851dff"),
                }}
            >
                <TextArea
                    rows={4}
                    placeholder="Type your heartfelt birthday wishes here..."
                    value={wishText}
                    onChange={(e) => setWishText(e.target.value)}
                    style={{
                        borderRadius: "8px",
                        resize: "none",
                        fontFamily: "Poppins, sans-serif",
                    }}
                />
            </Modal>
        </div>
    );
}
